<!--

    Copyright (c) 2017-present, Siklu Ltd.
    All rights reserved.

-->
<form (ngSubmit)="confirmDelete(customer.id)" class="dialog-form" name="deleteForm">
    <div class="siklu-mat-dialog-title" matDialogTitle>
        <h4>{{ 'entity.delete.title' | translate }}</h4>
        <button matDialogClose windeClose>
            <sui-svg-icon icon="cross"/>
        </button>
    </div>
    <div *ngIf="customer" class="siklu-mat-dialog-body" matDialogContent>
        <winde-alert-error></winde-alert-error>
        <p>
            {{ 'customer.delete.question' | translate: {name: customer.name | gtthTextEscape} }}
        </p>
    </div>
    <div class="siklu-mat-dialog-footer" matDialogActions>
        <button matDialogClose windeTransparent>
            <sui-svg-icon icon="cross"/>
            {{ 'entity.action.cancel' | translate }}
        </button>
        <button type="submit" windeRed>
            <sui-svg-icon icon="trash"/>
            {{ 'entity.action.delete' | translate }}
        </button>
    </div>
</form>
